export type Testimonial = {
  quote: string;
  name: string;
  role: string;
  location: string;
  flag: string;
  img: string;
};

export const testimonials: Testimonial[] = [
  {
    quote:
      "Every Monday I used to lose two hours building the weekly plan and chasing updates from three shifts. The planning prompts gave me a structure I reuse every week. I review it, tweak it, and I'm done before the first briefing.",
    name: 'Danielle R.',
    role: 'Warehouse Shift Supervisor',
    location: 'Columbus, OH · USA',
    flag: '🇺🇸',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/205b8b0d-b52d-4de2-85ea-33aded05cf35.jpg',
  },
  {
    quote:
      "I'm good with people, not with paperwork. The daily summary prompt and the report templates help me turn my rough notes into clear updates for my manager. I still check everything, but I'm not staring at a blank page anymore.",
    name: 'Marcus O.',
    role: 'Operations Team Leader',
    location: 'Manchester, UK',
    flag: '🇬🇧',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/7d0123c7-a8ce-45a0-8a29-59a15d0bcdd5.jpg',
  },
  {
    quote:
      'I was promoted six months ago and delegating was my weak spot. The delegation prompts made my instructions so much clearer: objective, deadline, follow-up. My team asks fewer questions and I spend way less time rewriting messages.',
    name: 'Priya S.',
    role: 'Retail Store Supervisor',
    location: 'Toronto, Canada',
    flag: '🇨🇦',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/2148fa52-837e-4c2d-bd88-f92c35ab2ef3.jpg',
  },
];
